<template>
  <div class="layout-wrap">
    <Loading />
    <div class="front-wrap">
      <router-view />
    </div>
  </div>
</template>
  
  <script lang="ts">
  export default {
    name: 'FrontEmptyLayout',
  }
  </script>
  
  <script setup lang="ts">
    import { defineAsyncComponent } from 'vue'
    // components
    const Loading = defineAsyncComponent(() => import('@/components/ui/Loading.vue'))
  </script>
  
<style scoped lang="scss">
.layout-wrap {
  height: 100%;
  .front-wrap {
    height: 100%;
  }
}
</style>